export function getPostCommunication(campaign) {
  if (campaign?.next_buy_cashback_offer_sales?.length > 0) {
    return campaign?.communication?.next_buy_cashback
  } else if (campaign?.dynamic_rule_offer_sales?.length > 0) {
    return campaign?.communication?.digital_voucher
  } else {
    return campaign?.communication?.default
  }
}

export function hasPostCommunication(campaign) {
  const communication = getPostCommunication(campaign)
  if (communication) {
    return communication?.sms?.active || communication?.whatsapp?.active
  }
}

export function getPostCommunicationType(campaign) {
  const communication = getPostCommunication(campaign)
  if (!communication) return ''

  let type = []
  if (communication?.sms?.active) {
    type.push('SMS')
  }
  if (communication?.whatsapp?.active) {
    type.push('Whatsapp')
  }
  return type.join(' e ')
}
